<div cdkDropList (cdkDropListDropped)="onDrop($event)">
  @for (placement of placements() | slice: 0 : showCount(); track placement.id) {
    <rt-candidate-profile-placement
      cdkDrag
      [placement]="placement"
      [placementActions]="placementActions()[placement.id]"
      [stageAutomationsFetchHandler]="stageAutomationsFetchHandler()"
      [isFirst]="$first"
      [isLast]="!hasShowMoreToggle() && $last"
      [offerTitleTooltipTemplate]="jobTooltipTemplate"
      [disqualifiedTooltipTemplate]="disqualifiedTooltipTemplate"
      [moreDropdownTemplate]="moreDropdownTemplate"
      collapsible="true"
      [hasDragHandle]="hasMultiplePlacements() && showDragHandles()"
      [stages]="placementStages()[placement.id]"
      [disqualifyReasons]="disqualifyReasons()"
      [isLoading]="loadingPlacementIds().includes(placement.id)"
      [openingIssue]="placementOpeningIssues()[placement.id]"
      [showJobFitScore]="hasPositiveOrHiddenRatings()"
      [interviewResults]="interviewResults()"
      [hiddenResultPreview]="
        $safeNavigationMigration(
          hiddenResultPreviews()[placement.offerId || placement.offer!.id]?.[0]
        )
      "
      [evaluationInsights]="evaluationInsights()"
      [evaluationScale]="evaluationScale()"
      [hasEvaluationImprovements]="hasEvaluationImprovements()"
      [theme]="theme()"
      (editHiringDetailsClick)="editHiringDetails.emit({ placement })"
      (previewJobClick)="previewJob.emit($event)"
      (proceedClick)="proceed.emit($event)"
      (disqualifyReasonSelect)="disqualify.emit($event)"
      (requalifyClick)="requalify.emit($event)"
      (cdkDragStarted)="onDragStart($event)"
      (cdkDragEnded)="onDragEnded()"
      (showAutomatedActionDetailsClick)="showAutomatedActionDetails.emit($event)"
      (editDisqualifyReasonsClick)="editDisqualifyReasons.emit()"
      (editWorkLocation)="editWorkLocation.emit($event)"
      (disqualifyReasonsActionsDetails)="disqualifyReasonActionsDetails.emit($event)"
      (evaluationMeterClick)="openEvaluationTab.emit()"
      [attr.data-cy]="'candidate-profile-sidebar:candidate-profile-placement:' + placement.offerId"
      [rtFeatureTooltip]="candidateInAnotherProcessTooltipConfig"
      [rtFeatureTooltipEnabled]="$index === 0 && !!showCandidateInAnotherProcessTooltip()"
    >
      <div #customPlaceholder *cdkDragPlaceholder class="custom-placeholder"></div>
      <rt-icon cdkDragHandle dragHandle name="drag-vertical" colorToken="colorIconLowDefault" />
    </rt-candidate-profile-placement>

    <ng-template #jobTooltipTemplate>
      <rt-candidate-offer-tooltip [placement]="placement" />
    </ng-template>

    <ng-template #disqualifiedTooltipTemplate>
      <rt-candidate-disqualified-tooltip [placement]="placement" />
    </ng-template>

    <ng-template #moreDropdownTemplate let-connectedOverlay="connectedOverlay">
      <rt-dropdown
        #moreDropdown
        [width]="DropdownWidth.Medium"
        (click)="preventCloseOnBackAction($event)"
      >
        @if (placementActions()[placement.id].editWorkLocations) {
          <rt-dropdown-item
            (click)="editWorkLocation.emit({ placement }); connectedOverlay.toggleOverlay(false)"
          >
            <rt-icon prefix name="place" />
            {{ 'app.candidate.placements.edit_work_location' | translate }}
          </rt-dropdown-item>
        }
        <rt-dropdown-item
          (click)="viewPipeline.emit({ placement }); connectedOverlay.toggleOverlay(false)"
          data-cy="candidate-profile-placement:more:go-to-offer"
        >
          <rt-icon prefix name="forward" />
          {{ 'app.candidate.go_to_job' | translate }}
        </rt-dropdown-item>
        <rt-dropdown-item
          (click)="
            placementActions()[placement.id].remove && remove.emit({ placement });
            connectedOverlay.toggleOverlay(false)
          "
        >
          <rt-icon prefix name="remove" />
          {{ 'app.candidate.remove_job' | translate }}
        </rt-dropdown-item>
        @if (
          placementActions()[placement.id].disqualify &&
          !placementNextStages()[placement.id] &&
          placement.hiredInThisPlacement
        ) {
          <rt-dropdown-item [targetFor]="disqualifyReasonsNestedTemplate">
            <rt-icon prefix name="block" />
            {{ 'app.candidate.disqualify' | translate }}
          </rt-dropdown-item>

          <ng-template #disqualifyReasonsNestedTemplate>
            <rt-disqualify-reasons-dropdown-template
              [collection]="disqualifyReasons()"
              [overlay]="connectedOverlay"
              hasEditOption="true"
              hasBackAction="true"
              (select)="
                disqualify.emit({ placement, disqualifyReason: $event.disqualifyReason });
                connectedOverlay.toggleOverlay(false)
              "
              (edit)="editDisqualifyReasons.emit(); connectedOverlay.toggleOverlay(false)"
              (goBack)="moreDropdown.prevTemplate()"
              (actionsDetails)="disqualifyReasonActionsDetails.emit($event.disqualifyReason)"
            />
          </ng-template>
        }
      </rt-dropdown>
    </ng-template>
  }
</div>

@if (this.hasShowMoreToggle()) {
  <rt-more-placements-toggle
    [remainingPlacementCount]="remainingPlacementsCount()"
    (valueChange)="showMoreToggleValue.set($event)"
    data-cy="candidate-profile:sidebar:placements:limiter-button"
  />
}

@if (placements().length === 0) {
  <div
    class="empty-state"
    [class.clickable]="canManageCandidates()"
    (click)="canManageCandidates() && addToJob.emit()"
    data-cy="candidate-profile-placements:empty-state"
  >
    {{ 'app.candidate.placements.empty_state.label' | translate }}
  </div>
}
